import { render, staticRenderFns } from "./AddTrade.vue?vue&type=template&id=95b6c73a"
import script from "./AddTrade.vue?vue&type=script&lang=js"
export * from "./AddTrade.vue?vue&type=script&lang=js"
import style0 from "./AddTrade.vue?vue&type=style&index=0&id=95b6c73a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports